import React from "react";
import * as utils from "common/utils";
import { cropViewModel } from "common/viewModels";
import Alert from "components/Alert";
import FileSummary from "./FileSummary";
import SummaryRow from "./SummaryRow";
import Watermark from "components/Watermark";

export const CropSummary = ({ before, after, refData }) => {
    const actualCrops = cropViewModel(after.details, refData);
    const baseCrops = before && cropViewModel(before.details, refData);
    const uniqueKeys = Array.from(new Set([...Object.keys(actualCrops), ...(before ? Object.keys(baseCrops) : [])]));

    if (uniqueKeys.length === 0) {
        return null;
    }

    return (
        <div className="ReportSection">
            <h1>Crops</h1>
            <div className="Table Table-Compressed">
                <Watermark />
                <table>
                    <thead>
                        <tr>
                            <th data-width="25"></th>
                            <th></th>
                            {before && (
                                <th className="u-textCenter u-before" data-width="12.5">
                                    {utils.truncateText(before.displayName, 35)}
                                </th>
                            )}
                            <th className={before ? "u-after u-textCenter" : "u-textCenter"} data-width="12.5">
                                {utils.truncateText(after.displayName, 35)}
                            </th>
                            {before && (
                                <th className="u-textCenter" data-width="16.7">
                                    Change
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {uniqueKeys.map((key) => {
                            const actualValue = actualCrops[key];
                            const baseValue = baseCrops && baseCrops[key];
                            const cropName = actualValue ? actualValue.name : baseValue.name;
                            const yieldUnit = (actualValue && actualValue.units) || (baseValue && baseValue.units);
                            return (
                                <React.Fragment key={key}>
                                    <SummaryRow category={cropName} prefix={cropName} baseValue={before ? (baseValue && baseValue.area && utils.round(baseValue.area, 1)) || 0 : undefined} actualValue={(actualValue && actualValue.area && utils.round(actualValue.area, 1)) || 0} label="Area" unit="ha" />
                                    <SummaryRow category=" " prefix={cropName} baseValue={before ? (baseValue && baseValue.yield && utils.round(baseValue.yield, 0)) || 0 : undefined} actualValue={(actualValue && actualValue.yield && utils.round(actualValue.yield, 0)) || 0} label="Yield" unit={yieldUnit} />
                                    <SummaryRow category=" " prefix={cropName} baseValue={before ? (baseValue && baseValue.grown && utils.round(baseValue.grown, 0)) || 0 : undefined} actualValue={(actualValue && actualValue.grown && utils.round(actualValue.grown, 0)) || 0} label="Pasture grown" unit="t DM/yr" />
                                    <SummaryRow category=" " prefix={cropName} baseValue={before ? (baseValue && baseValue.intake && utils.round(baseValue.intake, 0)) || 0 : undefined} actualValue={(actualValue && actualValue.intake && utils.round(actualValue.intake, 0)) || 0} label="Pasture intake" unit="t DM/yr" />
                                    <SummaryRow category=" " prefix={cropName} baseValue={before ? (baseValue && baseValue.supplements && utils.round(baseValue.supplements, 0)) || 0 : undefined} actualValue={(actualValue && actualValue.supplements && utils.round(actualValue.supplements, 0)) || 0} label="Supplements" unit="t DM/yr" />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const Crops = ({ before, after, refData, showFileComparison = true }) => {
    const actualCrops = cropViewModel(after.details, refData);
    const baseCrops = before && cropViewModel(before.details, refData);
    const uniqueKeys = Array.from(new Set([...Object.keys(actualCrops), ...(before ? Object.keys(baseCrops) : [])]));

    if (uniqueKeys.length === 0) {
        return (
            <div className="u-pt-lg">
                <Alert text="The selected analysis does not contain crop information" type="Info" />
            </div>
        );
    }

    return (
        <div className="ReportPage">
            {showFileComparison && before && <FileSummary before={before} after={after} mini={true} />}
            <CropSummary before={before} after={after} refData={refData} />
        </div>
    );
};
export default Crops;
